<template>
    <transition
        enter-class="opacity-0"
        enter-active-class="transition-opacity duration-200"
        leave-to-class="opacity-0"
        leave-active-class="transition-opacity duration-200"
    >
        <Layout :show-background="true" v-show="ready"
                container-class="flex flex-col justify-center min-h-screen py-10 sm:min-h-0">
            <div v-if="ready" class="w-full max-w-sm px-10 mx-auto">
                <div class="flex justify-center mb-8">
                    <img :src="config.service_logo" :alt="config.service_name"
                         class="block w-auto h-12">
                </div>
                <h1 class="mb-12 text-xl font-bold leading-tight text-center text-highlight-100">{{
                    _('vendor_title') }}</h1>
                <template v-if="hasProviders">
                    <section class="flex flex-wrap w-full px-2 mb-8">
                        <ProviderButton
                            v-for="provider in providers"
                            :key="provider.uuid"
                            :provider="provider"
                            @click.native="select(provider.uuid)"
                        />
                    </section>
                </template>
                <template v-if="hasCarriers">
                    <p class="mb-6 text-center text-highlight-100">{{ _('vendor_pay_with_provider')
                        }}</p>
                    <section class="flex flex-wrap w-full mb-8">
                        <div class="w-1/2 px-2" v-for="carrier in carriers" :key="carrier.uuid">
                            <ProviderButton
                                :provider="carrier"
                                @click.native="select(carrier.uuid)"
                            />
                        </div>
                    </section>
                </template>
            </div>
        </Layout>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import NProgress from 'nprogress'
import Layout from '@/components/Layout.vue'
import ProviderButton from '@/components/Providers/ProviderButton.vue'

export default {
    components: {
        Layout,
        ProviderButton,
    },
    computed: {
        ...mapGetters({
            fetched: 'localisation/fetched',
            _: 'localisation/translate',
            providers: 'providers/getProviders',
            hasProviders: 'providers/hasProviders',
            carriers: 'providers/getCarriers',
            hasCarriers: 'providers/hasCarriers',
            client: 'settings/getClient',
            params: 'settings/get',
        }),
    },
    data() {
        return {
            ready: false,
            config: '',
        }
    },
    watch: {
        fetched: {
            immediate: true,
            deep: true,
            handler(fetched) {
                if (fetched) {
                    setTimeout(() => {
                        this.ready = true
                        NProgress.done()
                    }, 1000)
                }
            },
        },
        carriers: {
            deep: true,
            handler() {
                if (!this.hasCarriers) {
                    const { uuid } = this.providers[0]
                    this.select(uuid)
                }
            },
        },
    },
    created() {
        this.$store.dispatch('providers/fetch', {
            platform: this.params.platform,
            company_uuid: this.params.company_uuid,
            cc: this.params.cc,
            api_key: this.params.api_key,
            lang: this.params.lang,
        }).then(() => {
            if (this.providers.length === 1 && this.carriers.length === 0) {
                this.select(this.providers[0].uuid)
            }

            if (this.carriers.length === 1 && this.providers.length === 0) {
                this.select(this.carriers[0].uuid)
            }
        })
    },
    async mounted() {
        this.config = await import(`@/resources/${this.client}`)
    },
    methods: {
        select(id) {
            this.$store.dispatch('providers/select', id)
                .then(() => this.$router.push({ name: 'Flow' }))
        },
    },
}
</script>
